var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-material-contents"},[_c('Header'),_c('div',{staticClass:"main-content"},[_c('ContentList')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }